module.exports = __webpack_public_path__ + "img/footer-about.08180f8d.png";